// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2Clwy","left":"StickyBox_left__29ZCY","right":"StickyBox_right__4KmA3"};